<div class="more-images" *ngIf="images?.length > 1">
  <div class="more-images-text">{{ "SERVICES.MORE-IMAGES" | translate }}</div>
  <p-galleria
    [(value)]="images"
    [(visible)]="displayCustom"
    [(activeIndex)]="activeIndex"
    [responsiveOptions]="responsiveOptions"
    [containerStyle]="{ 'max-width': '850px' }"
    [numVisible]="7"
    [circular]="true"
    [fullScreen]="true"
    [showItemNavigators]="true"
    [showThumbnails]="false"
    [baseZIndex]="100000">

    <ng-template pTemplate="item" let-item>
      <img [src]="item" style="width: 100%; display: block" alt="image" />
    </ng-template>
    <ng-template pTemplate="thumbnail" let-item>
      <div class="p-grid p-nogutter p-justify-center">
        <img [src]="item" style="display: block" alt="image" />
      </div>
    </ng-template>
  </p-galleria>

  <div *ngIf="images" class="p-grid" style="max-width: 400px">
    <div
      *ngFor="let image of images; let index = index"
      class="p-col-3 float-left mr-1"
      key="index">
      <div class="thumb-image">
        <img
          [src]="image"
          [alt]="image.alt"
          class="img-fluid single-image"
          style="cursor: pointer"
          (click)="imageClick(index)"
          (error)="errorHandler($event)"
          *ngIf="index < 5"/>
        <div
          class="last-image"
          *ngIf="images.length > 5 && index === 4"
          (click)="imageClick(index)">
          {{ "SERVICES.SHOW-MORE" | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
